import { Chip } from "@mui/material";
import { alpha, type Theme } from "@mui/material/styles";
import type { JSX, ReactNode } from "react";

/** A compact attribute pill for a bot card (persona / sources / filters /
 * anonymous / no-clarifying). Extracted from `BotsPanel.tsx`. */
export function Pill({
  children,
  tone = "default",
}: {
  children: ReactNode;
  tone?: "default" | "warn" | "mute";
}): JSX.Element {
  const sx =
    tone === "warn"
      ? { color: "warning.main", bgcolor: (t: Theme) => alpha(t.palette.warning.main, 0.1) }
      : tone === "mute"
        ? { color: "text.disabled", bgcolor: "surfaceSoft" }
        : { color: "primary.main", bgcolor: (t: Theme) => alpha(t.palette.primary.main, 0.12) };
  return (
    <Chip
      size="small"
      label={children}
      sx={{
        height: "auto",
        borderRadius: 0.5,
        fontSize: 12,
        "& .MuiChip-label": { px: 0.75, py: 0.25 },
        ...sx,
      }}
    />
  );
}
